import React from 'react'
import Select from 'react-select'
import { useSelector } from 'react-redux'
import { Controller, useFieldArray, useFormContext } from 'react-hook-form'
import CustomModal from '../customModal'
const RegionsDeleteModal = ({ isOpen, toggleModal, onHandleSubmit }) => {
  const { control } = useFormContext()
  const { allRegion } = useSelector(({ region }) => region)
  const { fields } = useFieldArray({
    control,
    name: 'regionDelete'
  })

  const adminList = fields[0]?.admins || []
  const cityList = fields[0]?.cities || []

  return (
    <CustomModal isOpen={isOpen} toggle={toggleModal} title={`Update Region`} size="lg">
      {adminList?.length > 0 && (
        <div className="card-div-group">
          <div className="card-div-header">
            <h4 className="redional_admin_title">Regional Admin</h4>
          </div>
          <div className="row scrollable-container">
            {adminList.map((item, index) => {
              return (
                <div className="col-md-6" key={index}>
                  <div className="delete_data_style">
                    <div>
                      {item?.admin?.first_name} {item?.admin?.last_name}
                      <div style={{color:"black"}}>({item?.admin?.email})</div>
                    </div>
                    <div className="form-group input_text border-remove dark_border_divs deletemodal_filed_width">
                      <Controller
                        name={`regionDelete.[0].admins.${index}.region_id`}
                        control={control}
                        render={({ field }) => (
                          <Select
                            {...field}
                            className={`react-selectcomponent form-control select-box-filed`}
                            getOptionLabel={(option) => `${option.region}`}
                            getOptionValue={(option) => `${option.region_id}`}
                            options={allRegion || []}
                            isSearchable={true}
                            placeholder={`Select Region`}
                            classNamePrefix="select_kanakku"
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      )}
      {cityList?.length > 0 && (
        <div className="card-div-group">
          <div className="card-div-header">
            <h4 className="redional_admin_title">Cities</h4>
          </div>
          <div className="row scrollable-container">
            {cityList.map((item, index) => {
              return (
                <div className="col-md-6" key={index}>
                  <div style={{ marginBottom: '12px' }} className="delete_data_style">
                    <div>{item?.city}</div>
                    <div className="form-group input_text border-remove dark_border_divs deletemodal_filed_width">
                      <Controller
                        name={`regionDelete.[0].cities.${index}.region_id`}
                        control={control}
                        render={({ field }) => (
                          <Select
                            {...field}
                            className={`react-selectcomponent form-control select-box-filed`}
                            getOptionLabel={(option) => `${option.region}`}
                            getOptionValue={(option) => `${option.region_id}`}
                            options={allRegion || []}
                            isSearchable={true}
                            placeholder={`Select Region`}
                            classNamePrefix="select_kanakku"
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      )}
      <div className="multi_btn_div modal-button-group">
        <button type="submit" className="btn btn-primary common-field-btn save_btn_size" onClick={onHandleSubmit}>
          {`Update`}
        </button>
      </div>
    </CustomModal>
  )
}

export default RegionsDeleteModal
